import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../core/services/api.service';
import { Plant } from 'src/app/Models/plant';
import { Vehicle } from '../../../../Models/vehicle';
import { MessageService } from '../../../../core/services/message.service';
import { Location } from '@angular/common';

@Component({
  selector: 'vehicles-add',
  templateUrl: './vehicles-add.component.html',
  styleUrls: ['./vehicles-add.component.scss']
})

export class VehiclesAddComponent implements OnInit {

  selectedPlant: Plant;
  id: any;
  form: FormGroup;
  submitted: boolean;
  vehicle: Vehicle;
  plants: Plant[] = [];
  submitButtonText: string = 'GENERAL.LABELS.CREATE';
  isEditing: boolean;
  selectedVehicle: string;
  vehicleTypes: string[] = ['GENERAL.ENUMS.VEHICLE_TYPE.TRUCK', 'GENERAL.ENUMS.VEHICLE_TYPE.VAN', 'GENERAL.ENUMS.VEHICLE_TYPE.MOTORCYCLE'];

  constructor(private activatedRoute: ActivatedRoute, private formBuilder: FormBuilder, private apiService: ApiService,
    private messageService: MessageService, private location: Location) {
    this.id = this.activatedRoute.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      registerNumber: ['', Validators.required],
      color: ['', Validators.required],
      capacity: ['', [Validators.required]],
      type: ['', Validators.required]
    });

    if (this.id) {
      this.isEditing = true;
      this.submitButtonText = 'GENERAL.LABELS.EDIT';
      this.apiService.get('api/vehicle/' + this.id).subscribe((data: any) => {
        this.vehicle = data.data;
        this.getPlants();
        this.form = this.formBuilder.group({
          name: [this.vehicle.name, Validators.required],
          registerNumber: [this.vehicle.registerNumber, Validators.required],
          color: [this.vehicle.color, Validators.required],
          capacity: [this.vehicle.capacity, [Validators.required]],
          type: [this.vehicleTypes[this.vehicle.vehicleType], Validators.required]
        });
      });

    } else {
      this.getPlants();
    }

  }

  get controls() { return this.form.controls; }


  getPlants() {
    this.apiService.get('api/plant/findAll').subscribe(response => {
      if (response.data) {
        this.plants = response.data;
        if (this.vehicle) {
          this.plants.forEach(item => {
            if (item.id == this.vehicle.plant.id) {
              this.selectedPlant = item;
              return;
            }
          });
          if (!this.selectedPlant) {
            this.selectedPlant = this.plants[0];
          }
        }

      }
    });
  }

  back() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    let model: Vehicle = this.form.value as Vehicle;

    model.vehicleType = this.vehicleTypes.indexOf(this.selectedVehicle);
    model.plant = this.selectedPlant;
    if (this.isEditing) {
      model.id = this.id;
      this.apiService.put('api/vehicle', model).subscribe((response: any) => {
        this.messageService.success("VEHICLES.MESSAGES.SUCCESS", "VEHICLES.MESSAGES.VEHICLE_UPDATED");
        this.location.back();
      });
    }
    else {
      this.apiService.post('api/vehicle', model).subscribe((response: any) => {
          this.messageService.success("VEHICLES.MESSAGES.SUCCESS", "VEHICLES.MESSAGES.VEHICLE_SAVED");
          this.location.back();
      });
    }
  }
}
